/**
 * We want to clear any previous errors or warnings on a condition if the field for that condition is changed.
 */

import { useQueryErrorStateContext } from 'modules/queryBuilder/contexts';
import {
  useConditionComparatorFieldPath,
  useConditionFieldFieldPath,
  useConditionFieldTypeFieldPath,
  useConditionValueFieldPath,
  useConditionValuesFieldPath,
} from 'modules/queryBuilder/hooks/condition';

export const useResetErrorStateOnFieldChange = () => {
  const conditionFieldPath = useConditionFieldFieldPath();
  const conditionFieldTypePath = useConditionFieldTypeFieldPath();
  const conditionComparatorPath = useConditionComparatorFieldPath();
  const conditionValuePath = useConditionValueFieldPath();
  const conditionValuesPath = useConditionValuesFieldPath();

  const { resetErrorsFromFieldPath } = useQueryErrorStateContext();

  return () => {
    [
      conditionFieldPath,
      conditionFieldTypePath,
      conditionComparatorPath,
      conditionValuePath,
      conditionValuesPath,
    ].forEach((fieldPath) => {
      resetErrorsFromFieldPath(fieldPath);
    });
  };
};
